import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers/form.helper';
import { IFormValue } from 'common/models';
import { ReactComponent as CloseIcon } from 'app/assets/images/redesign/close.svg';
import { ISettingsIntegrationsContractCustomer } from 'entities/Settings/Settings.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  customer: ISettingsIntegrationsContractCustomer | null;
  onClose: () => void;
  onSave: (id: number, value: string, onSuccess?: () => void) => void;
}

export const SettingsCreateCustomerIdModal: FC<IComponentProps> = ({ open, loading, customer, onClose, onSave }) => {
  const [form] = useForm();

  const handleClose = () => {
    onClose();
    form.resetFields();
  };

  const onSubmit = ({ customerId }: IFormValue) => {
    if (customer) {
      onSave(customer.id, customerId, handleClose);
    }
  };

  useEffect(() => {
    if (open && customer?.customerId) {
      form.setFieldsValue({ customerId: customer.customerId });
    }
  }, [open, customer]);

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      title={customer?.type === 'consignee' ? `ID грузополучателя «${customer?.name}»` : `ID покупателя «${customer?.name}»`}
      centered
      open={open}
      onCancel={handleClose}
      zIndex={1001}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
        <Form.Item label="ID" name="customerId" rules={[rules.required()]}>
          <Input placeholder="Добавьте ID" allowClear={{ clearIcon: <CloseIcon className="icon-close-input" /> }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
